import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectSupplierInfo } from '../../../../store/slices/supplierInfoSlice';
import InfoRow from './InfoRow';
import InfoSection from './InfoSection';

const SecurityCalculationSection = () => {
    const { t } = useTranslation();
    const supplierInfo = useSelector(selectSupplierInfo);
    const { amounts } = supplierInfo || {};
    const { guaranteeSecurity } = amounts || { guaranteeSecurity: {} };

    return (
        <InfoSection title={t('supplier-info.security-calculation')}>
            <InfoRow
                label={t('supplier-info.total-security')}
                value={guaranteeSecurity?.totalGuarantee || 0}
                suffix="%"
            />
            <InfoRow
                label={t('supplier-info.required-security')}
                value={guaranteeSecurity?.requiredGuarantee || 0}
                suffix='€'
            />
            <InfoRow
                label={t('supplier-info.covered')}
                value={guaranteeSecurity?.coveredAmount || 0}
                suffix='€'
            />
            <InfoRow
                label={t('supplier-info.open-amount')}
                value={guaranteeSecurity?.openBeforeRecalculation || 0}
                suffix='€'
            />
            <InfoRow
                label={t('supplier-info.open-amount')}
                value={guaranteeSecurity?.openAfterRecalculation || 0}
                suffix='€'
            />
            <InfoRow
                label={t('supplier-info.less-payments-made')}
                value={guaranteeSecurity?.lessPaid || 0}
                isNegative={guaranteeSecurity?.lessPaid < 0}
                suffix='€'
            />
            <InfoRow
                label={t('supplier-info.retention')}
                value={guaranteeSecurity?.withholding || 0}
                suffix='€'
            />
            <InfoRow
                label={t('supplier-info.correction-insufficient-security')}
                value={guaranteeSecurity?.correction || 0}
                suffix='€'
            />
        </InfoSection>
    );
};

export default SecurityCalculationSection;
